import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { listAppUsers, normalizeAppUsersListResponse } from '../services/appUsers';
import { appUsersQueryKeys } from './query-keys';

export const useAppUsersQuery = (params = {}, options = {}) =>
  useQuery({
    queryKey: appUsersQueryKeys.list(params),
    queryFn: async () => {
      const result = await listAppUsers(params);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch users');
      }
      return normalizeAppUsersListResponse(result.data, params);
    },
    placeholderData: keepPreviousData,
    ...options,
  });
